<template>
  <div>
    <BaseOverlay/>
    <Widget></Widget>
    <router-view></router-view>
  </div>
</template>

<script>
import {ARBS_PAGE_MOBILE_FRINGE_RES} from '../const';
import {VTooltip} from 'v-tooltip';

window.hide_hints = function() {
  window.vm.hints.openModal();
};

VTooltip.options.defaultTemplate =
    '<div class="tooltip" role="tooltip">' +
    '<div class="tooltip-arrow"></div>' +
    '<div class="tooltip-inner"></div>' +
    '<span class="tooltip-close-icon" onclick="window.hide_hints()"></span>' +
    '</div>';
VTooltip.options.disposeTimeout = 1000;
import {mapMutations} from 'vuex';

export default {
  name: 'TheMainLayout',
  data() {
    return {
      isMobileView: false,
    };
  },
  components: {
    Widget: () => import('./Widget.vue'),
  },
  methods: {
    ...mapMutations({
      commitToggleHints: 'TOGGLE_HINTS',
    }),
    onResize() {
      this.isMobileView = window.innerWidth <= ARBS_PAGE_MOBILE_FRINGE_RES;
    },
    openModal() {
      this.$bus.$emit('show-modal', {
        component: () => import('./scanner-common/modals/CheckHideHintsModal.vue'),
      });
    },
  },
  created() {
    this.isMobileView = window.innerWidth <= ARBS_PAGE_MOBILE_FRINGE_RES;
    if (window.current_user && window.current_user.settings !== undefined) {
      if (JSON.parse(window.current_user.settings).profile &&
          JSON.parse(window.current_user.settings).profile.show_hints !== undefined &&
          JSON.parse(window.current_user.settings).profile.show_hints === 0) {
        this.commitToggleHints(false);
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      // eslint-disable-next-line no-invalid-this
      window.addEventListener('resize', this.onResize);
    });
    vm.hints = this;
  },
};
</script>

<style lang="scss">
.tooltip {
  display: block !important;
  position: relative;
  z-index: 10000000;
  .tooltip-close-icon {
    font-family: 'brankic';
    cursor: pointer;
    position: absolute;
    color: white;
    font-size: 14px;
    right: 5px;
    top: -5px;
    &::before {
      content: "\e660";
    }
  }

  .tooltip-inner {
    background: rgba(0, 0, 0, 0.72);
    color: white;
    border-radius: 5px !important;
    padding: 5px 30px 5px 20px;
    font-size: 12px;
    &:hover {
      background: rgba(0, 0, 0, 1);
    }
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgba(0, 0, 0, 0.72);
    z-index: 1;
    &:hover {
      border-color: rgba(0, 0, 0, 1);
    }
  }

  &[x-placement^="top"] {
    margin-bottom: 1px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 1px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 1px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 1px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
